module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00572.c262b90a.jpg";